<script setup lang="ts">
defineProps<{
  src: string;
}>();
</script>

<template>
  <iframe
    :src="src"
    class="w-full h-full rounded-xl border-0"
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
    title="Google Maps"
    allow="fullscreen"
  />
</template>
